import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_USERS_SERVICE_BASE,
  async load() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetUsers`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async save(user) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/SaveUser`, user, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async getClientLocations(clientId) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetLocationsByClient?id=${clientId}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async uniqueUserName(userName) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/uniqueUserName?id=${userName.trim()}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadClients() {
    await authentication.isAuthenticated();
    return axios
      .get(process.env.VUE_APP_API_CLIENT_SERVICE_BASE + "/GetClients", {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      })
      .then(response => {
        return response.data;
      });
  }
};
